const Navigation = {
  install(Vue) {
    Vue.directive("nv", {
      bind: function(el, binding, vnode) {
        if (binding.arg === "scope") {
          if (!binding.value) return
          el.setAttribute("nv-scope", binding.value)
          el.setAttribute("id", binding.value)
          if (binding.modifiers.current) el.setAttribute("nv-scope-current", "")

          el.addEventListener("nv-scope-focus", () => {
            vnode.context.$emit("nv-scope-focus")
          })
          el.addEventListener("nv-scope-blur", () => {
            vnode.context.$emit("nv-scope-blur")
          })

          if (el.getAttribute("nv-exit-protect") !== "") el.addEventListener("nv-exit", () => __.platform.go())
          el.addEventListener("nv-home", () => __.platform.go())
        } else {
          el.setAttribute("nv-el", "")
          if (binding.modifiers.current) el.setAttribute("nv-el-current", "")
          else if (binding.value) el.setAttribute("nv-el-current", "")
        }
      },
      unbind: function() {},
      componentUpdated: function(el) {
        if (el.getAttribute("nv-el") === "" && !el.classList.contains("nv-el")) el.classList.add("nv-el")
      }
    })
  }
}

export default Navigation
